import { createContext } from 'react'
import type { User } from '@/types'

export interface AuthContextType {
  user: User | null
  isLoading: boolean
  isAuthenticated: boolean
  // T129-008: derived convenience flag — true when user.role === 'accountant'.
  // Callers use this instead of comparing role strings directly.
  isAccountant: boolean
  login: (email: string, password: string) => Promise<User | null>
  logout: () => Promise<void>
  // EP-150: the token-clearing + React Query cache-clearing half of logout(),
  // with none of its network calls (revoke, push unregister). A deletion
  // request already revoked the tokens server-side, so calling the full
  // logout() would fire an authenticated request with a dead token, hit the
  // 401 refresh path, fail that too, and hard-redirect via
  // window.location.href, wiping the very page state (the scheduled date)
  // the caller is about to navigate to /login with.
  clearSession: () => void
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined)
